"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadowLoginMagicForm = void 0;

var _molecules = require("../../molecules");

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../atoms");

var _Loading = require("../../molecules/Loading");

var _helpers = require("../../util/helpers");

var _localforage = _interopRequireDefault(require("localforage"));

require("./ShadowLoginMagicForm.css");

var _limiter = require("../../util/limiter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ShadowLoginMagicForm = function ShadowLoginMagicForm(_ref) {
  var width = _ref.width,
      center = _ref.center,
      generalError = _ref.generalError,
      setGeneralError = _ref.setGeneralError,
      setStep = _ref.setStep,
      redirectURL = _ref.redirectURL,
      userId = _ref.userId,
      emailHash = _ref.emailHash,
      setEmail = _ref.setEmail,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      didFetchUsername = _useState2[0],
      setDidFetchUsername = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      firstName = _useState4[0],
      setFirstName = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      lastName = _useState6[0],
      setLastName = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      name = _useState8[0],
      setName = _useState8[1];

  var requestUserInfo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                setGeneralError(null); // send magic email

                // send magic email
                var body = {
                  operationName: "getUserNames",
                  variables: {
                    user_id: parseInt(userId),
                    email_hash: emailHash.toLowerCase()
                  },
                  query: "query getUserNames($user_id: Int!, $email_hash: String!) {\n  userNames(user_id: $user_id, email_hash: $email_hash) {\n    first_name\n    last_name\n    name\n    email\n    __typename\n  }\n}\n"
                };
                var params = {
                  method: "POST",
                  headers: {
                    Accept: "*/*",
                    "Content-Type": "application/json"
                  },
                  mode: "cors",
                  body: JSON.stringify(body)
                };
                (0, _limiter.limiter)(_objectSpread({
                  url: process.env.REACT_APP_GRAPHQL_API
                }, params), function (success, failure) {
                  fetch(process.env.REACT_APP_GRAPHQL_API, params).then(function (response) {
                    return response.json();
                  }).then(function (json) {
                    if (json && json.data) {
                      success();
                      resolve(json.data);
                    } else {
                      var error = "Something went wrong";

                      if (json && json.error) {
                        error = json.error.message;
                      }

                      failure();
                      reject(error);
                    }
                  }).catch(function (err) {
                    failure();
                    setGeneralError("No user found");
                    resolve(false);
                  });
                });
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestUserInfo() {
      return _ref2.apply(this, arguments);
    };
  }();

  var requestSendMagicEmailWithUserId = function requestSendMagicEmailWithUserId(userId, emailHash, proceedUrl, authUrl) {
    return new Promise(function (resolve, reject) {
      setGeneralError(null); // send magic email

      var body = {
        operationName: "sendLoginCodeForShadowUser",
        variables: {
          user_id: parseInt(userId),
          email_hash: emailHash.toLowerCase(),
          proceed_url: proceedUrl,
          auth_url: authUrl
        },
        query: "mutation sendLoginCodeForShadowUser($user_id: Int!, $email_hash: String!, $proceed_url: String!, $auth_url: String!) {\n  sendLoginCodeForShadowUser(\n    user_id: $user_id\n    email_hash: $email_hash\n    proceed_url: $proceed_url\n    auth_url: $auth_url\n  ) {\n    success\n    error\n    __typename\n  }\n}\n"
      };
      var params = {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json"
        },
        mode: "cors",
        body: JSON.stringify(body)
      };
      (0, _limiter.limiter)(_objectSpread({
        url: "graphql"
      }, params), function (success, failure) {
        fetch(process.env.REACT_APP_GRAPHQL_API, params).then(function (response) {
          return response.json();
        }).then(function (json) {
          if (json && json.data) {
            success();
            resolve(json.data);
          } else {
            var error = "Something went wrong";

            if (json && json.error) {
              error = json.error.message;
            }

            failure();
            reject(error);
          }
        }).catch(function (err) {
          failure();
          setGeneralError("Invalid user for login");
          handleRemoveShadowUser();
          resolve(false);
        });
      });
    });
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return sendMagicEmailWithUserIdAndHash(userId, emailHash);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var sendMagicEmailWithUserIdAndHash = function sendMagicEmailWithUserIdAndHash(userId, emailHash) {
    return new Promise(function (resolve, reject) {
      setGeneralError(null); // send magic email

      var path = window.location.href.split("?");
      var queryParams = "";

      if (path[1]) {
        queryParams = "?" + path[1];
      }

      var proceedUrl = path[0] + "/userid/${userId}/token/${token}" + queryParams;
      var authUrl = "".concat(process.env.REACT_APP_WEB_API, "/webapp/autologin-url/send");
      requestSendMagicEmailWithUserId(userId, emailHash, proceedUrl, authUrl).then(function () {
        console.log("autologin");
        setStep("enter-code");
        resolve(true);
      }).catch(function () {
        console.log("sendMagic error");
        setGeneralError("User not found");
        handleRemoveShadowUser();
        resolve(false);
      });
    });
  };

  (0, _react.useEffect)(function () {
    if (userId && emailHash && !didFetchUsername) {
      setDidFetchUsername(true);
      requestUserInfo().then(function (data) {
        if (data && data.userNames) {
          var userNames = data.userNames;
          setFirstName(userNames.first_name);
          setLastName(userNames.last_name);
          setEmail(userNames.email);
          setName(userNames.name);
        } else {
          handleRemoveShadowUser();
        }
      }).catch(function (err) {
        console.log("fetchUsernames error", err);
        handleRemoveShadowUser();
      });
    }
  }, [userId, emailHash, didFetchUsername]);

  var handleRemoveShadowUser = function handleRemoveShadowUser() {
    _localforage.default.removeItem("shadowUserId");

    _localforage.default.removeItem("shadowUserHash");

    setStep("login-magic");
  };

  var styles = {};

  if (width) {
    styles.maxWidth = width;
  }

  if (center) {
    styles.margin = "0 auto";
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    style: styles,
    className: "ShadowLoginForm"
  }, name && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    center: true,
    spacingBottom: "4"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "sign-in-label"
  }, "Continue as"), /*#__PURE__*/_react.default.createElement(_molecules.Avatar, {
    className: "user-avatar",
    size: 40,
    imageUrl: "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/avatars?user=").concat(userId),
    initials: (0, _helpers.getInitials)(firstName, lastName),
    marginLeft: "2",
    marginRight: "2"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "sign-in-label"
  }, name)), /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trkAction: "Shadow Login Email Sign In Pressed",
    content: "Email sign in code",
    primary: true,
    onClick: onSubmit,
    spacingTop: "4",
    marginTop: "8"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    touchable: true,
    onClick: handleRemoveShadowUser,
    color: _atoms.Color.Trace,
    trkAction: "Shadow Login Not me Pressed",
    content: "This is not me",
    marginTop: "8"
  }), children), !name && /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "loading-container",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_Loading.Loading, null)));
};

exports.ShadowLoginMagicForm = ShadowLoginMagicForm;